module.exports = __webpack_public_path__ + "img/hk.04c30652.png";